module.exports = __webpack_public_path__ + "img/bg_avatar_male_22.756aa24d.png";